import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import QuoteForm from './QuoteForm';

class QuoteModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    quote: PropTypes.object,
    shipper: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  };

  handleHide = () => {
    this.props.onHide();
  };

  render() {
    const { show, quote, t } = this.props;
    const title =
      quote && quote.quote_id
        ? t('EDIT_QUOTE_WITH_VALUE', { editQuote: quote.quote_id })
        : t('GET_A_QUOTE');

    return (
      <Dialog open={show} onOpenChange={this.handleHide}>
        <DialogContent className="w-screen h-screen max-w-none max-h-none overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <QuoteForm
            onCancel={this.handleHide}
            shipper={this.props.shipper}
            quote={this.props.quote}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

export default withTranslation()(QuoteModal);
